<template>
  <article class="downloads">
    <div class="downloads_banner"></div>
    <div class="downloads_content base_content">
      <div class="downloads_title base_title">Загрузки</div>
      <div class="downloads_body">
        <div class="downloads_info">
          Лаунчер включает все нынешние моды, шейдеры и текстур-паки, нужен для
          авторизации на сервере и загружает автоматические обновления при необходимости.
          Также есть возможность отдельно загружать пользовательские шейдеры без трудностей.
          <br>Актуальная версия лаунчера: <span class="colored_version">v0.1</span>
        </div>
        <div class="downloads_links" v-if="!mobile">
          <div class="main_link">
            <a :href="targetedDownloadLink" class="base_link" target="_blank">
              <div class="download_button">Скачать лаунчер</div>
            </a>
          </div>
          <div class="others">
            <a class="base_link disabled"
              target="_blank">
              <div class="download_button">
                <i class="dw-icon linux wh-30"></i>
              </div>
            </a>
            <a class="base_link disabled"
              target="_blank">
              <div class="download_button">
                <i class="dw-icon macos wh-30"></i>
              </div>
            </a>
            <a href="//assets.divine-world.ru/minecraft/exe/launcher" class="base_link"
              target="_blank">
              <div class="download_button">
                <i class="dw-icon windows wh-30"></i>
              </div>
            </a>
          </div>
        </div>
        <div class="downloads_links mobile" v-else>
          Чтобы скачать лаунчер, зайдите с компьютера.
        </div>
      </div>
      <div class="downloads_assets" v-if="assets">
        <div class="downloads_assets-title">Дополнительные ссылки</div>
        <table class="downloads_assets-table">
          <tr class="downloads_assets-row" v-for="(link, idx) in assets" :key="idx">
            <td class="downloads_assets-data">{{ link.name }}</td>
            <td class="downloads_assets-data padded">
              <a :href="link.link" class="base_link resource">{{ link.resource_name }}</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </article>
</template>
<script>
import Backend from '../services/backend.service';

export default {
  name: 'Downloads',
  data() {
    return {
      backend: new Backend(),
      mobile: false,
      assets: null,
    };
  },
  methods: {
    checkMobile() {
      if (!/Windows|Mac OS X|Macintosh|Linux/i.test(navigator.userAgent)) {
        this.mobile = true;
      }
    },
    getAssets() {
      this.backend.get('/assets/downloads')
        .then((resp) => {
          this.assets = resp.external_links;
        })
        .catch(err => console.log(err));
    },
  },
  computed: {
    targetedDownloadLink() {
      let format = 'jar';
      if (/Windows/i.test(navigator.userAgent)) {
        format = 'exe';
      }
      return `//assets.divine-world.ru/minecraft/${format}/launcher`;
    },
  },
  mounted() {
    this.checkMobile();
    this.getAssets();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.downloads{
  &_banner{
    aspect-ratio: 16/7;
    width: 100%;
    background: url('/static/downloads-banner.jpg') no-repeat 50% 50% / cover;
    pointer-events: none;
  }
  &_body{
    display: flex;
    max-width: 60%;
    margin: 0 auto;
    font-family: $font;
    color: white;
    font-size: 20px;
    .colored_version{
      color: $light-green;
    }
  }
  &_info{
    margin-right: 25px;
  }
  &_links{
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &.mobile{
      justify-content: center;
      color: $green;
      min-width: 180px;
    }
    .main_link{
      .download_button{
        height: 50px;
        font-size: 32px;
        line-height: 50px;
        white-space: nowrap;
      }
    }
    .others{
      display: flex;
      justify-content: space-between;
      .download_button{
        padding: 0;
      }
      .disabled{
        cursor: default;
        opacity: .5;
      }
    }
  }
  &_assets{
    max-width: 60%;
    margin: 0 auto;
    font-family: $font;
    color: white;
    font-size: 20px;
    &-title{
      padding: 25px 0;
      font-family: $title-font;
      font-size: 16px;
      color: $light-green;
    }
    &-row{
      margin-bottom: 5px;
    }
    &-data{
      font-family: $font;
      color: white;
      font-size: 17px;
      &.padded{
        padding: 0px 10px;
      }
      .resource{
        color: $light-green;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Downloads.vue